<template>
    <ListaAgendadoresLegacy
        title="¿En qué consiste este servicio?"
        title-icon-src="/img/afinamiento/vector_negro.png"
        title-class="text-[28px] md:text-[32px] font-bold"
        :title-icon-width="20"
        :title-icon-height="26"
        :items="pasos"
        wrapper-class="bg-GRIS_CLARO"
    />

</template>

<script setup lang="ts">
import ListaAgendadoresLegacy from '@/components/Comunes/ListaAgendadoresLegacy.vue';

const pasos = [
  { key: 1, icon_src: '/img/afinamiento/servicios/ico1.png', icon_alt: 'Lavado de inyectores', texto: 'Lavado de inyectores' },
  { key: 2, icon_src: '/img/afinamiento/servicios/ico2.png', icon_alt: 'Revisión y corrección de tiempo básico de encendido', texto: 'Revisión y corrección de tiempo básico de encendido' },
  { key: 3, icon_src: '/img/afinamiento/servicios/ico3.png', icon_alt: 'Cambio de filtro de aire', texto: 'Cambio de filtro de aire' },
  { key: 4, icon_src: '/img/afinamiento/servicios/ico4.png', icon_alt: 'Limpieza de cámara de filtro de aire', texto: 'Limpieza de cámara de filtro de aire' },
  { key: 5, icon_src: '/img/afinamiento/servicios/ico5.png', icon_alt: 'Sustitución de filtro de aire', texto: 'Sustitución de filtro de aire' },
  { key: 6, icon_src: '/img/afinamiento/servicios/ico6.png', icon_alt: 'Diagnóstico con escáner', texto: 'Diagnóstico con escáner' },
  { key: 7, icon_src: '/img/afinamiento/servicios/ico7.png', icon_alt: 'Cambio de bujías', texto: 'Cambio de Bujias' },
];
</script>
